import { GolfHoleScore, HoleByHoleRowItem } from './styles'
import { EMPTY_VALUE } from './utils'

export const EmptyHoleCells = () => {
  return (
    <>
      {Array(20)
        .fill(null)
        .map((_, index) => (
          <HoleByHoleRowItem key={index}>
            <GolfHoleScore>{EMPTY_VALUE}</GolfHoleScore>
          </HoleByHoleRowItem>
        ))}
    </>
  )
}
